import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledNextServiceCardContainer: any = styled.div`
  ${({ theme }) => {
    return `
      padding-top: ${theme.size.static350};

      @media (min-width: ${Breakpoints.b1600}px) {
        padding-top: ${theme.size.static450};
      }
    `;
  }}
`;

export const StyledCardContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 278px;

  & [class^='CardWrapper-'],
  & [class*=' CardWrapper-'] {
    border: 1px solid #dfe4e8 !important;
    box-shadow: none !important;
    gap: 0 !important;
    padding: 0 !important;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    min-width: 331px;
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    ${({ cardsAmount, theme }) => {
      return `
        min-width: ${cardsAmount === 2 ? theme.size.grid006 : `calc(${theme.size.grid004} + 2.8vw)`};
      `;
    }}
  }
`;

export const StyledCardHeader: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      justify-content: space-between;
      padding: ${theme.size.static250} ${theme.size.static300} ${theme.size.static300} ${theme.size.static300};
      width: 100%;

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.static350} ${theme.size.static400} ${theme.size.static350} ${theme.size.static400};
      }
    `;
  }}
`;

export const StyledHeaderLeftSection: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      flex: 0 0 auto;

      & > *:first-child {
        color: #001E50;
      }

      & > *:nth-child(2) {
        align-items: center;
        cursor: pointer;
        display: flex;
        gap: ${theme.size.static150};
        width: max-content;
      }
    `;
  }}
`;

export const StyledHeaderRightSection: any = styled.div`
  align-items: end;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;

  p {
    color: #001e50;
  }
`;

export const StyledCardBody: any = styled.div`
  ${({ theme, is10KMileage }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
      padding: ${theme.size.static300} ${theme.size.static300} ${theme.size.static250} ${theme.size.static300};

      @media (min-width: ${Breakpoints.b1600}px) {
        padding: ${theme.size.static350} ${theme.size.static400};
        gap: ${theme.size.static250};
      }

      ${
        is10KMileage &&
        `
        .start-icon-wrapper {
          display: none;
        }
      `
      }
    `;
  }}
`;

export const StyledMileageProgressContainer: any = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledMileagePreviousContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;

  & > *:first-child {
    color: #001e50;
  }

  & > *:nth-child(2) {
    color: #6a767d;
  }
`;

export const StyledMileageNextContainer: any = styled.div`
  align-items: end;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;

  & > *:first-child {
    color: #001e50;
  }

  & > *:nth-child(2) {
    color: #6a767d;
  }
`;
